var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"chart"},[(_vm.title)?_c('strong',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.data.length)?_c('div',{staticClass:"chart-container",style:(_vm.boxStyle)},[_c('d3-bar-chart',{attrs:{"data":_vm.data,"options":_vm.chartOptions}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }